import confetti from "canvas-confetti";

// Brand-colored confetti burst — two converging side cannons plus a center
// pop, matching canvas-confetti's well-known "school pride" recipe. Used for
// genuine milestone moments (final submission), not every save.
const BRAND_COLORS = ["#6f0000", "#a00000", "#d97706", "#fbbf24", "#ffffff"];

export function fireConfetti() {
  const end = Date.now() + 1400;

  (function frame() {
    confetti({ particleCount: 4, angle: 60, spread: 55, origin: { x: 0, y: 0.7 }, colors: BRAND_COLORS, startVelocity: 45, scalar: 1.1 });
    confetti({ particleCount: 4, angle: 120, spread: 55, origin: { x: 1, y: 0.7 }, colors: BRAND_COLORS, startVelocity: 45, scalar: 1.1 });
    if (Date.now() < end) requestAnimationFrame(frame);
  })();

  confetti({ particleCount: 90, spread: 100, origin: { y: 0.6 }, colors: BRAND_COLORS, startVelocity: 55, ticks: 200, scalar: 1.05 });
}
